// extracted by mini-css-extract-plugin
export default {"favoriteListContainer":"FavoriteList_favoriteListContainer__LdQ6-"};